<template>
  <div v-if="mostrar" class="modal-overlay" @click="cerrarFormulario">
    <div class="modal-formulario" @click.stop>
      <div class="modal-header">
        <h3>{{ esEdicion ? '✏️ Editar Pregunta' : '➕ Nueva Pregunta' }}</h3>
        <button @click="cerrarFormulario" class="close-btn">×</button>
      </div>
      
      <form @submit.prevent="guardarPregunta" class="modal-body">
        <div class="form-row">
          <div class="form-group">
            <label>🔢 Orden</label>
            <input v-model.number="formulario.orden" type="number" min="1" class="form-control" required>
          </div>
          
          <div class="form-group">
            <label>🎯 Tipo de Pregunta</label>
            <select v-model="formulario.tipoPregunta" class="form-control" required>
              <option value="">Seleccionar...</option>
              <option value="1">Pregunta Normal</option>
              <option value="2">Mensaje de Inicio</option>
              <option value="3">Acción Intermedia</option>
              <option value="4">Mensaje Final</option>
            </select>
          </div>
        </div>
        
        <div class="form-group">
          <label>❓ Texto de la Pregunta</label>
          <textarea v-model="formulario.pregunta" class="form-control" rows="3" required
                    placeholder="Escribe aquí la pregunta que verá el usuario..."></textarea>
        </div>
        
        <div class="form-row">
          <div class="form-group">
            <label>📝 Tipo de Respuesta</label>
            <select v-model="formulario.tipoRespuesta" class="form-control" required>
              <option value="">Seleccionar...</option>
              <option value="1">Texto Libre</option>
              <option value="2">Solo Números</option>
              <option value="3">Cédula</option>
              <option value="4">Teléfono</option>
              <option value="5">Archivo/Imagen</option>
              <option value="6">Sí/No</option>
            </select>
          </div>
          
          <div class="form-group">
            <label>⚡ Acción Siguiente</label>
            <select v-model="formulario.accionSiguiente" class="form-control" required>
              <option value="">Seleccionar...</option>
              <option value="1">Continuar</option>
              <option value="2">Escalar</option>
              <option value="3">Cerrar Resuelto</option>
              <option value="4">Solicitar Mensaje</option>
            </select>
          </div>
        </div>
        
        <div class="form-group">
          <label class="checkbox-label">
            <input type="checkbox" v-model="formulario.esObligatoria">
            ✓ Respuesta Obligatoria
          </label>
        </div>
        
        <div v-if="[2, 4].includes(parseInt(formulario.accionSiguiente))" class="form-group">
          <label>💬 Mensaje de Escalado</label>
          <textarea v-model="formulario.mensajeEscalado" class="form-control" rows="2"
                    placeholder="Mensaje que se mostrará antes de escalar..."></textarea>
        </div>
        
        <div class="form-group">
          <label>🔍 Validación (Regex - Opcional)</label>
          <input v-model="formulario.validacion" type="text" class="form-control"
                 placeholder="Ej: ^[0-9]{10}$ (para 10 dígitos)">
        </div>
      </form>
      
      <div class="modal-footer">
        <button type="button" @click="cerrarFormulario" class="btn btn-secondary">
          Cancelar
        </button>
        <button @click="guardarPregunta" class="btn btn-primary" :disabled="guardando">
          {{ guardando ? 'Guardando...' : (esEdicion ? 'Actualizar' : 'Crear') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormularioPregunta',
  props: {
    mostrar: {
      type: Boolean,
      default: false
    },
    esEdicion: {
      type: Boolean,
      default: false
    },
    preguntaEditando: {
      type: Object,
      default: null
    },
    guardando: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formulario: {
        orden: '',
        pregunta: '',
        tipoPregunta: '',
        tipoRespuesta: '',
        accionSiguiente: '',
        esObligatoria: true,
        mensajeEscalado: '',
        validacion: ''
      }
    }
  },
  watch: {
    mostrar(newVal) {
      if (newVal) {
        this.inicializarFormulario()
      }
    },
    preguntaEditando: {
      handler(newVal) {
        if (newVal && this.esEdicion) {
          this.cargarDatosEdicion()
        }
      },
      deep: true
    }
  },
  methods: {
    inicializarFormulario() {
      if (this.esEdicion && this.preguntaEditando) {
        this.cargarDatosEdicion()
      } else {
        this.resetearFormulario()
      }
    },
    
    cargarDatosEdicion() {
      this.formulario = {
        id: this.preguntaEditando.id_pregunta,
        orden: this.preguntaEditando.orden,
        pregunta: this.preguntaEditando.pregunta,
        tipoPregunta: this.preguntaEditando.tipo_pregunta,
        tipoRespuesta: this.preguntaEditando.tipo_respuesta,
        accionSiguiente: this.preguntaEditando.accion_siguiente,
        esObligatoria: this.preguntaEditando.es_obligatoria === 1,
        mensajeEscalado: this.preguntaEditando.mensaje_escalado || '',
        validacion: this.preguntaEditando.validacion || ''
      }
    },
    
    resetearFormulario() {
      this.formulario = {
        orden: '',
        pregunta: '',
        tipoPregunta: '',
        tipoRespuesta: '',
        accionSiguiente: '',
        esObligatoria: true,
        mensajeEscalado: '',
        validacion: ''
      }
    },
    
    guardarPregunta() {
      this.$emit('guardar-pregunta', { ...this.formulario })
    },
    
    cerrarFormulario() {
      this.$emit('cerrar-formulario')
      this.resetearFormulario()
    }
  }
}
</script>

<style scoped>
/* 📝 Estilos mejorados del modal formulario */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.4s ease-out;
}

.modal-formulario {
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border-radius: 20px;
  box-shadow: 
    0 25px 50px rgba(41, 70, 151, 0.2),
    0 10px 20px rgba(0,0,0,0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.8);
  max-width: 750px;
  width: 90%;
  max-height: 85vh;
  overflow: hidden;
  animation: slideUp 0.4s ease-out;
  border: 2px solid rgba(41, 70, 151, 0.1);
  position: relative;
}

.modal-formulario::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #294697, #007bff, #17a2b8);
  border-radius: 20px 20px 0 0;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem;
  background: linear-gradient(135deg, #294697 0%, #1D3C7F 50%, #007bff 100%);
  color: white;
  position: relative;
  overflow: hidden;
}

/* 🔧 Efecto shimmer removido - diseño más sobrio */

.modal-header h3 {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.close-btn {
  background: rgba(255,255,255,0.2);
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.close-btn:hover {
  background: rgba(255,255,255,0.3);
  transform: scale(1.1);
  box-shadow: 0 4px 12px rgba(0,0,0,0.3);
}

.modal-body {
  padding: 2.5rem;
  max-height: 65vh;
  overflow-y: auto;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.5rem;
}

.form-group {
  margin-bottom: 1.5rem;
  position: relative;
}

.form-group label {
  display: block;
  margin-bottom: 0.75rem;
  font-weight: 700;
  color: #294697;
  font-size: 1rem;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.form-control {
  width: 100%;
  padding: 1rem;
  border: 2px solid #e9ecef;
  border-radius: 12px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  box-shadow: inset 0 2px 4px rgba(0,0,0,0.05);
}

.form-control:focus {
  border-color: #294697;
  box-shadow: 
    0 0 0 4px rgba(41, 70, 151, 0.1),
    inset 0 2px 4px rgba(0,0,0,0.05);
  outline: none;
  background: #ffffff;
  transform: translateY(-1px);
}

.form-control::placeholder {
  color: #adb5bd;
  font-style: italic;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  font-weight: 600;
  color: #294697;
  padding: 0.75rem;
  background: linear-gradient(135deg, #e8f4fd, #d1ecf1);
  border-radius: 10px;
  border: 2px solid rgba(0, 123, 255, 0.1);
  transition: all 0.3s ease;
}

.checkbox-label:hover {
  background: linear-gradient(135deg, #d1ecf1, #bee5eb);
  border-color: rgba(0, 123, 255, 0.2);
  transform: translateY(-1px);
}

.checkbox-label input[type="checkbox"] {
  width: 18px;
  height: 18px;
  accent-color: #294697;
}

.modal-footer {
  display: flex;
  justify-content: center;
  gap: 2rem;
  padding: 1rem 0rem;
  background: linear-gradient(135deg, #f8f9fa, #e9ecef);
  border-top: 1px solid rgba(41, 70, 151, 0.1);
}

.btn {
  padding: 0.875rem 2rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* 🔧 Efecto de brillo en botones removido */

.btn-primary {
  background: linear-gradient(135deg, #294697, #007bff);
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: linear-gradient(135deg, #1D3C7F, #0056b3);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(41, 70, 151, 0.4);
}

.btn-primary:disabled {
  background: linear-gradient(135deg, #6c757d, #495057);
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.btn-secondary {
  background: linear-gradient(135deg, #6c757d, #495057);
  color: white;
}

.btn-secondary:hover {
  background: linear-gradient(135deg, #545b62, #3d4043);
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(108, 117, 125, 0.4);
}

/* Responsive mejorado */
@media (max-width: 768px) {
  .form-row {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .modal-formulario {
    width: 95%;
    max-height: 90vh;
    border-radius: 16px;
  }
  
  .modal-header {
    padding: 1.5rem;
  }
  
  .modal-header h3 {
    font-size: 1.2rem;
  }
  
  .modal-body {
    padding: 1.5rem;
  }
  
  .modal-footer {
    flex-direction: column;
    padding: 1.5rem;
  }
  
  .btn {
    padding: 0.75rem 1.5rem;
  }
}

@media (max-width: 480px) {
  .modal-body {
    padding: 1rem;
  }
  
  .modal-header {
    padding: 1rem;
  }
  
  .form-control {
    padding: 0.875rem;
  }
}

/* Animaciones mejoradas */
@keyframes fadeIn {
  from { 
    opacity: 0; 
    backdrop-filter: blur(0px);
  }
  to { 
    opacity: 1; 
    backdrop-filter: blur(4px);
  }
}

@keyframes slideUp {
  from { 
    transform: translateY(50px) scale(0.95); 
    opacity: 0; 
  }
  to { 
    transform: translateY(0) scale(1); 
    opacity: 1; 
  }
}

/* 🔧 Animación shimmer removida */
</style>
